export default "__VITE_ASSET__f13e3f62__"